import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_UnblurImage = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/unblur-image',
			name: 'AI Unblur — Image Unblur Tool | Lift',
			description:
				'Unblur pictures online with AI. Fix blurry photos instantly, increase image quality, improve photo clarity. No watermarks. Try Lift Unblur now.',
			url: 'https://liftapp.ai/unblur-image',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/unblur-image#product' },
				{ '@id': 'https://liftapp.ai/unblur-image#howto' },
				{ '@id': 'https://liftapp.ai/unblur-image#benefits' },
				{ '@id': 'https://liftapp.ai/unblur-image#faq' },
				{ '@id': 'https://liftapp.ai/unblur-image#why-lift' },
				{ '@id': 'https://liftapp.ai/unblur-image#explore-tools' },
				{ '@id': 'https://liftapp.ai/unblur-image#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/unblur-image#product',
			name: 'Image Unblur Tool',
			description:
				'Unblur pictures online with AI. Fix blurry photos instantly, increase image quality, improve photo clarity. No watermarks. Try Lift Unblur now.',
			url: 'https://liftapp.ai/unblur-image',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/unblur-image#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let AI upscale it',
					text: 'Lift’s AI removes blur, sharpens edges, and restores lost details',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download or share',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/unblur-image#benefits',
			name: 'Who can benefit from AI Unblur?',
			description:
				'AI Unblur is ideal for anyone who need clearer, sharper photos instantly',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'PContent creators and influencers for professional-looking posts',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Businesses and e-commerce sellers improving product visuals',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Marketers elevating ads and social media',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Event planners preserving memories in crisp detail',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students or professionals can clarify scanned documents, screenshots, or images',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Photographers can restore older or low-quality images effortlessly',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'AI Unblur makes professional-quality restoration simple and accessible',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/landing_2.3cdd75c1.webp',
				name: 'Flowers in Focus: Clearer Daisies with Unblur Tool',
				description:
					'Diagonally split image: blurry field of white daisies on the left, clear and sharp on the right.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/unblur-image#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Unblur?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Unblur is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Unblur work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, keeps your facial features accurate, and reimagines them in anime style with artistic backgrounds, colors, and details. Everything is automatic — no manual editing needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it upscale an image to 4K?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Upload a photo up to 20MB, select the 4× option, and Lift will generate a crisp 4K PNG or JPG — ideal for high-resolution needs.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/unblur-image#why-lift',
			name: 'Why Lift’s Lift AI Unblur stands out',
			description:
				'Discover how Lift’s AI-powered Image Unblur tool delivers professional results with smart, affordable, and cross-platform support.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/landing_3.5c97ee89.webp',
				name: 'Adventures Unblurred: Restoring Detail to Travel Photos',
				description:
					'Diagonally split image: blurry photo of a man next to a white van on the left, clear and sharp on the right.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/unblur-image#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/unblur-image#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Unblur Image',
					item: 'https://liftapp.ai/unblur-image',
				},
			],
		},
	],
};
